import React, { useState, useEffect } from 'react';
import PatientProfile from '../../components/PatientProfile/PatientProfile';
import ConsultationHistory from '../../components/ConsultationHistory/ConsultationHistory';
import PrescriptionList from '../../components/PrescriptionList/PrescriptionList';
import FileUpload from '../../components/FileUpload/FileUpload';
import NextAppointments from '../../components/NextAppointments/NextAppointments';
import ExamResults from '../../components/ExamResults/ExamResults';
import Layout from '../../components/layout/Layout';
import PatientSearch from '../../components/PatientSearch/PatientSearch';

const ProntuarioPage = () => {
  const [selectedPatient, setSelectedPatient] = useState(null);
  const [consultations, setConsultations] = useState([]);
  const [prescriptions, setPrescriptions] = useState([]);
  const [appointments, setAppointments] = useState([]);
  const [examResults, setExamResults] = useState([]);

  const handleSelectPatient = (patient) => {
    setSelectedPatient(patient);

    // Simular a carga de dados do prontuário do paciente
    setConsultations([
      {
        date: '2024-09-10',
        diagnosis: 'Hipertensão',
        prescription: 'Remédio X',
        doctor: 'Dr. Gustavo Vasconcelos',
        notes: 'Recomenda-se dieta balanceada e exercícios.',
      },
      {
        date: '2024-08-20',
        diagnosis: 'Diabetes',
        prescription: 'Remédio Y',
        doctor: 'Dr. Gustavo Vasconcelos',
        notes: 'Controle de glicemia diário recomendado.',
      },
    ]);

    setPrescriptions([
      {
        date: '2024-09-10',
        medication: 'Remédio X',
        dosage: '500mg',
        frequency: '2x ao dia',
        administrationRoute: 'Oral',
        doctor: 'Dr. Gustavo Vasconcelos',
      },
      {
        date: '2024-08-20',
        medication: 'Remédio Y',
        dosage: '200mg',
        frequency: '1x ao dia',
        administrationRoute: 'Oral',
        doctor: 'Dr. Gustavo Vasconcelos',
      },
    ]);

    setAppointments([
      {
        date: '2024-09-20',
        time: '14:00',
        patientName: patient.name,
        doctor: 'Dr. Gustavo Vasconcelos',
      },
      {
        date: '2024-09-25',
        time: '10:00',
        patientName: patient.name,
        doctor: 'Dr. Gustavo Vasconcelos',
      },
    ]);

    setExamResults([
      {
        date: '2024-09-05',
        type: 'Hemograma Completo',
        result: 'Normal',
        doctor: 'Dr. Gustavo Vasconcelos',
        lab: 'Laboratório XYZ',
      },
      {
        date: '2024-08-25',
        type: 'Raio-X Tórax',
        result: 'Normal',
        doctor: 'Dr. Gustavo Vasconcelos',
        lab: 'Clínica ABC',
      },
    ]);
  };

  return (
    <Layout>
      <div className="max-w-7xl mx-auto p-8 space-y-12">
        <h1 className="text-4xl font-bold text-primary text-center mb-10">
          Prontuário Eletrônico Completo
        </h1>

        {/* Componente de busca de paciente */}
        <div className="mb-10">
          <PatientSearch onSelectPatient={handleSelectPatient} />
        </div>

        {selectedPatient && (
          <>
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
              {/* Informações Pessoais */}
              <div className="lg:col-span-1 bg-white shadow-lg rounded-lg p-6">
                <h2 className="text-3xl font-semibold text-secondary mb-4">
                  Informações Pessoais
                </h2>
                <PatientProfile patient={selectedPatient} />
              </div>

              {/* Consultas */}
              <div className="lg:col-span-2 bg-white shadow-lg rounded-lg p-6">
                <h2 className="text-3xl font-semibold text-secondary mb-4">
                  Consultas
                </h2>
                <ConsultationHistory consultations={consultations} />
              </div>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
              {/* Prescrições */}
              <div className="lg:col-span-1 bg-white shadow-lg rounded-lg p-6">
                <h2 className="text-3xl font-semibold text-secondary mb-4">
                  Prescrições
                </h2>
                <PrescriptionList prescriptions={prescriptions} />
              </div>

              {/* Resultados de Exames */}
              <div className="lg:col-span-2 bg-white shadow-lg rounded-lg p-6">
                <h2 className="text-3xl font-semibold text-secondary mb-4">
                  Resultados de Exames
                </h2>
                <ExamResults exams={examResults} />
              </div>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
              {/* Agendamentos */}
              <div className="bg-white shadow-lg rounded-lg p-6">
                <h2 className="text-3xl font-semibold text-secondary mb-4">
                  Agendamentos
                </h2>
                <NextAppointments appointments={appointments} />
              </div>

              {/* Documentos */}
              <div className="bg-white shadow-lg rounded-lg p-6">
                <h2 className="text-3xl font-semibold text-secondary mb-4">
                  Documentos
                </h2>
                <FileUpload
                  onUpload={(file) =>
                    console.log(`Arquivo carregado: ${file.name}`)
                  }
                />
              </div>
            </div>
          </>
        )}
      </div>
    </Layout>
  );
};

export default ProntuarioPage;
